$(function() {
    const elements = document.querySelectorAll('.fade-in-animation-trigger');

    const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
        }
    });
    }, {
    threshold: 0.6 
    });

elements.forEach(el => observer.observe(el));
});

$(function(){
    const fieldSelector = '.e_field_control .form-control, .formGroup .form-control, .form-group .form-control';

    function getFieldContainer($input) {
        return $input.closest('.e_field_control, .formGroup, .form-group');
    }

    function getFieldLabel($input, $container) {
        const id = $input.attr('id');
        if (id) {
            const $label = $container.find('label[for="' + id + '"]');
            if ($label.length) {
                return $label;
            }
        }
        return $container.children('label').not('.error').first();
    }

    function syncFieldState($input, isActive) {
        const $container = getFieldContainer($input);
        if (!$container.length) {
            return;
        }

        if (typeof isActive === 'undefined') {
            isActive = $input.is(':focus');
        }

        const $label = getFieldLabel($input, $container);
        $container.toggleClass('active-field', isActive);
        $label.toggleClass('active-field', isActive);

        const value = $input.val();
        const hasValue = Array.isArray(value) ? value.length > 0 : String(value ?? '').length > 0;
        $container.toggleClass('filled-field', hasValue);
        $label.toggleClass('filled-field', hasValue);
    }

    $(fieldSelector).on('focus blur input change', function() {
        syncFieldState($(this));
    });

    $(document).on('select2:open', fieldSelector, function() {
        syncFieldState($(this), true);
    });
    $(document).on('select2:close', fieldSelector, function() {
        syncFieldState($(this), false);
    });
    $(document).on('select2:select select2:clear', fieldSelector, function() {
        syncFieldState($(this));
    });

    $(fieldSelector).each(function() {
        syncFieldState($(this), false);
    });
});

$(function() {
    $('.post-login-message-trigger').on('click', function() {
        $('.post-login-message-trigger').toggleClass('active');
        $('.post-login-message-content').toggleClass('sHidden');
    });
});

$(function() {
    var $customerMessageForm2026 = $(".e_customerMessageDetails #customerMessageForm2026");
	if ($customerMessageForm2026.length > 0) { 
		var $customerMessageForm2026Confirm = $(".e_customerMessageDetails #confimationMessage");
		$customerMessageForm2026Confirm.hide();
		$customerMessageForm2026.validate({
			rules: ele.validations.customerMessage.rules,
			messages:ele.validations.customerMessage.messages,
			errorElement:"div",
			errorPlacement:function(error,element){
				element.parent("div").append(error);
			},
            submitHandler: function(form) {            
                let responseMessage = document.getElementsByClassName('e_responseMessage');
                if (responseMessage.length > 0) {
                    responseMessage[0].remove();
                }
            
                const $form = $(form);
            
                if ($form.find(".e_serverValidationError").length > 0) {
                    const errorNotification = ele.notification('Please check the fields for errors before submitting the form', 'error');
                    $form.prepend(errorNotification);
                    return false;
                }
            
                ele.mouse.preventDoubleClickWithValidation("#contact-form-submit");
            
                const formData = $form.serializeObject();
            
                // Wait for reCAPTCHA before submitting
                if (typeof grecaptcha !== 'undefined' && grecaptcha.execute) {
                    grecaptcha.execute(ele.config.reCaptcha.publicKey, {
                        action: ele.config.reCaptcha.event
                    }).then(function (token) {
                        // Add reCAPTCHA data to formData
                        formData['g-recaptcha-response'] = token;
                        formData['g-recaptcha-action'] = ele.config.reCaptcha.event;
            
                        console.log(formData);
            
                        $.ajax({
                            type: 'POST',
                            url: ele.uri.buildUrl("customerMessageAdd"),
                            data: formData,
                            success: function (response) {
                                console.log(response);
                                let JSONresponse;
                                try {
                                    JSONresponse = JSON.parse(response);
                                } catch (e) {
                                    console.error("Invalid JSON in response", e);
                                    return;
                                }
            
                                if (JSONresponse.success) {
                                    $customerMessageForm2026.fadeOut("fast");
                                    $customerMessageForm2026Confirm.fadeIn("fast");
                                    $("body").addClass('customerMessageSent');
                                } else {
                                    if (JSONresponse.CAPTCHAERROR) {
                                        const errorNotification = ele.notification(JSONresponse.detail, 'error');
                                        $form.prepend(errorNotification);
                                        $('#captcha').addClass('error');
                                        if (responseMessage.length > 0) responseMessage[0].scrollIntoView();
                                    } else {
                                        console.error("Unknown error:", JSONresponse);
                                    }
                                }
                            },
                            error: function () {
                                const errorNotification = ele.notification(i18n('js_contact_form_error'), 'error');
                                $form.prepend(errorNotification);
                                if (responseMessage.length > 0) responseMessage[0].scrollIntoView();
                            }
                        });
                    });
                } else {
                    const errorNotification = ele.notification('reCAPTCHA is not available. Please try again later.', 'error');
                    $form.prepend(errorNotification);
                }
            
                return false; // prevent default form submit
            },            
            invalidHandler: function(form, validator) {
                let responseMessage = document.getElementsByClassName('e_responseMessage');
                if(responseMessage.length > 0){ responseMessage[0].remove(); }                
                //this is for some reason called before errors are displayed, so force display
                var errors = validator.numberOfInvalids();
                if (errors) {
                    validator.showErrors();
                    //list of errors at the top of the screen.
                    $("#errorList").remove();
                    var errorDiv = $("<div id='errorList' class='error' tabindex=\"0\"></div>");
                    errorDiv.append("<h4>" + i18n('js_valid_title') + "</h4>");
                    for (var v in validator.invalid) {
                        if (!validator.invalid.hasOwnProperty(v)) {continue;}
                        //ids needed to link labels to fields
                        errorDiv.append("<p class='error-element-link'" + "data-element=" + v + ">"+validator.invalid[v].replace( "Error: ", "")+"</p>");
                    }
                    $customerMessageForm2026.prepend(errorDiv);
                    $('html, body').animate({
                        scrollTop: $("#errorList").offset().top - 20
                    }, 200, function() {
                        $("#errorList").focus();
                    });
                    $('.error-element-link').click(function(ev){
                        let elem = $(this).data('element');
                        $('html, body').animate({
                            scrollTop: $("[name='" + elem + "']").offset().top - 40
                        }, 200, function() {
                            $("#errorList").focus();
                        });
                    });
                }
            }
        });

        $customerMessageForm2026.find(':input').on('change',function(){
			// Remove server validation errors when input change
			$(this).parent().find('.e_serverValidationError').remove();
		});
	}
});

function updateCompletedNavPillsIcons() {
    // Support both class names defensively; this file uses `complete`
    const $completedLinks = $('.nav-link.complete, .nav-link.completed');

    // Swap index to a check icon on completed links
    $completedLinks.find('.nav-pills-index').each(function () {
        const $index = $(this);

        if (!$index.data('originalHtml')) {
            $index.data('originalHtml', $index.html());
        }

        // Avoid thrashing if already swapped
        if ($index.find('i.fa-check, i.fa-solid.fa-check').length === 0) {
            $index.html('<i class="fa-solid fa-check"></i>');
        }
    });

    // Restore original content if a link is no longer completed
    $('.nav-link').not('.complete, .completed').find('.nav-pills-index').each(function () {
        const $index = $(this);
        const original = $index.data('originalHtml');
        if (original) {
            $index.html(original);
        }
    });
}

async function getLawguideMostRecentNode() {
    const blankState = {
        title: 'You haven\'t used the law guide yet',
        articleDetails: 'Click here to start reading',
        link: '?event=lawguide&collection=3'
    };

    let { title, articleDetails, link } = blankState;

    try {
        const response = await fetch('?event=getLawguideMostRecentNode', {
            method: 'GET'
        });

        if (!response.ok) {
            throw new Error(`Request failed: ${response.status}`);
        }

        const data = await response.json();

        // Must be a success, DATA must be present as an object and not be an empty object
        if (data.SUCCESS && data.DATA && Object.keys(data.DATA).length > 0) {
            // convert &amp; to &
            title = data.DATA.NODENAME.replace('&amp;', '&');
            articleDetails = `<span>${data.DATA.PARENT.replace('&amp;', '&')}</span>`;
            link = `?event=${data.DATA.TYPE}&node=${data.DATA.NODE}`;
        }

    } catch (error) {
        console.error('Could not load most recent lawguide node:', error);

    } finally {
        $('#storeLawguideMostRecentNode .title').text(title);
        $('#storeLawguideMostRecentNode .article-details').html(articleDetails);
        $('#recent-lawguide-link').attr('href', link);
    }
}

async function getLawguideMostRecentNodeUK() {
    const blankState = {
        title: 'You haven\'t used the law guide yet',
        articleDetails: 'Click here to start reading',
        link: '?event=lawguide&collection=2'
    };

    let { title, articleDetails, link } = blankState;

    try {
        const response = await fetch('?event=getLawguideMostRecentNode', {
            method: 'GET'
        });

        if (!response.ok) {
            throw new Error(`Request failed: ${response.status}`);
        }

        const data = await response.json();

        // Must be a success, DATA must be present as an object and not be an empty object
        if (data.SUCCESS && data.DATA && Object.keys(data.DATA).length > 0) {
            // convert &amp; to &
            title = data.DATA.NODENAME.replace('&amp;', '&');
            articleDetails = `<span>${data.DATA.PARENT.replace('&amp;', '&')}</span>`;
            link = `?event=${data.DATA.TYPE}&node=${data.DATA.NODE}`;
        }

    } catch (error) {
        console.error('Could not load most recent lawguide node:', error);

    } finally {
        $('#storeLawguideMostRecentNode .title').text(title);
        $('#storeLawguideMostRecentNode .article-details').html(articleDetails);
        $('#recent-lawguide-link').attr('href', link);
    }
}

$(function() {
    updateCompletedNavPillsIcons();
});

$(function () {
    $('#jurisdictionSelector,#ticketcategoryid,#RegisterFormCustomerTitle,#DOBDay,#DOBMonth,#DOBYear,#RegisterFormJurisdictionId,#state,#jurisdictionID,#document-folder-id,#customercounty,#document-folder-id,#policyNumbePrefix').select2();
    $('#customercounty').select2({ width: '100%' })
});

// start of ele2023.js
$(function() {
    // Store the value of the furthest step we have validated to ensure that we keep validating it if the user leaves the tab
    let regValidationTabHistory = 1; 

    const swiper = new Swiper(".swiper", {
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 10,
        effect: 'coverflow',
        spaceBetween: 30,
        loop: true,
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 0,
            modifier: 1,
            slideShadows: false,
        },        
        pagination: {
          el: ".swiper-pagination",
          clickable: false,
        },
        breakpoints: {
            900: {
                slidesPerView: 'auto'
            },
            760: {
                slidesPerView: 2
            }

        } ,
        autoplay: {
            delay: 7000, // time duration between slides (in ms)
            disableOnInteraction: false, // if set to true, autoplay will stop after user interaction
        },        
      });

    if(ele.config?.USWorkflowFeatures?.storeLawguideMostRecentNode && $('#storeLawguideMostRecentNode').length > 0) {
        getLawguideMostRecentNode(); 
    }

    if(ele.config?.USWorkflowFeatures?.storeLawguideMostRecentNodeUK && $('#storeLawguideMostRecentNode').length > 0) {
        getLawguideMostRecentNodeUK();
    }

    $('.regNextButton, #RegisterFormSubmit').on('click', function() {
        // Get the data attributes for the button
        let currentStep = $(this).data("section"); 
        regValidationTabHistory = currentStep;
        let target = $('.ele-registerForm .nav-pills .nav-item .nav-link');

        // Validate all steps the customer has tried to submit in this session
        let isValid = validateSection(regValidationTabHistory);

        if (isValid) {    
            // Mark all valid steps as completed            
            target.eq(currentStep - 1).removeClass('invalid').addClass('complete');
            updateCompletedNavPillsIcons();

            if($('.nav-pills .nav-item').length === currentStep){
                // Do nothing and let normal form submission take place
                return true
            } else { 
                // Move to the next relevant tab
                $(`#pills-step${currentStep + 1}-tab`).tab('show');
            }
        } else {
            // Extract the parent tab from the data of each error element so we can flag it with an error class
            let errorTabs = [];
            let validTabs = [];
            let errors = $('.error-element-link');
            errors.each(function(index, item) {
                let elem = $(item).data('element');
                let target = $("[name='" + elem + "']");
                // seperate successfully validated sections from those containing errors without setting classes on non started sections
                if(!errorTabs.includes(target.data('tab'))){
                    errorTabs.push(target.data('tab'));
                }
            });
            // seperate successfully validated sections from those containing errors without setting classes on non started sections
            for(s = 0; s < regValidationTabHistory; s++){
                if(!errorTabs.includes(s + 1)){
                    validTabs.push(s + 1);
                };
            }          
            // Add appropriate classes to the now identified valid/error tabs
            errorTabs.forEach(function(currentValue) {
                $(`#pills-step${currentValue}-tab`).removeClass('complete').addClass('invalid');
            });
            validTabs.forEach(function(currentValue) {
                $(`#pills-step${currentValue}-tab`).removeClass('invalid').addClass('complete');
            });            
            updateCompletedNavPillsIcons();
        }  
    });  

    // This catch-all is an attempt to handle any fields that are currently ignored as the customer has jumped tabs or the tabs are not selected
    // It does not directly compete with the general validation that runs when the user clicks the next button 
    // It does not compete with the on change event which does not seem to fire on text inputs
    // It can compete with the generic blur event that runs when the user leaves the field but that could be being supressed by the multistage reg form, duplication here can cause issues with the
    // CustomerLogin field so we ignore that partiular field, the validation there is AJAX and two validations firing cause the call to be cancelled 
    $('#RegisterForm input').on('blur', function(){
        // Check to see if the input name is CustomerLogin or username, ignore if so
        if ($(this).attr('name') !== 'CustomerLogin' && $(this).attr('id') !== 'username') {
            try {
                $(this).valid();
            } catch (error) {
                console.log(error);
            }
        }
    });

    function validateSection(section) {
        // First, tell jQuery Validate to ignore all inputs
        $("#RegisterForm").validate({
            ignore: "*"
        });

        // Gather the classes of all the sections we ned to validate in this round
        let sectionList = [];
        for (let s = 1; s <= section; s++ ){
            sectionList.push(`.pills-step${s}-input`);     
        }
        let ignoreString  = sectionList.map(function(section) {
            return section;
        }).join(", ");
    

        // Then, update the ignore option to only validate our desired sections
        $("#RegisterForm").validate().settings.ignore = `:not(${ignoreString})`;    

        // Check if the form is valid now
        let isValid = $("#RegisterForm").valid();
        
        // Return the form settings to their original state
        $("#RegisterForm").validate().settings.ignore = ele.validations.customer.ignore;

        return isValid;
    }
    
    function resetRegistrationForm(){
        $(`#pills-step1-tab`).tab('show');
    }
    
    // validate the registration form sections when the page is loaded
    if ($('#RegisterForm').length > 0) {
        resetRegistrationForm();
    }

    $('#all-tab').on('click', function(){
        $('.tab-pane').addClass('tab-pane-force-reveal');  
    });

    $('.indiv-tab').on('click', function(){
        $('.tab-pane').removeClass('tab-pane-force-reveal');  
    });

    if ($('.ele-subsiteProducts').length > 0){
        // Get the hash fragment from the URL
        var hashFragment = window.location.hash;

        // Check if a hash value exists
        if (hashFragment) {
            // Remove the '#' symbol from the hash fragment
            var argumentValue = hashFragment.slice(1);

            // Show the tab
            if($(`#tab-control-${argumentValue}`).length > 0){
                $(`#tab-control-${argumentValue}`).tab('show');
                let navElement = $("#pills-tab").offset().top;
                let scrollToPosition = navElement - 200;

                $("html, body").animate({
                    scrollTop: scrollToPosition
                  }, 0);
            } else {
                // If no fragment, open the all tab
                $('#all-tab').trigger('click');
            }
        } else {
            // If no fragment, open the all tab
            $('#all-tab').trigger('click');
        }
    }
    
    $("#RegisterFormCustomerPassword").on('input', function() {
        $(this).valid(); 
    });

    $('.clear-icon i').on('click', function(){
        $('#search').val(''); // Clear the input field
        $('#search').focus(); // Optional: focus the input after clearing
    });


    var $inputField = $('.registerWithoutCodeInput')
    var $submitButton = $('#registerWithoutCodeSubmit')

    $submitButton.prop('disabled', false);

    $inputField.on('input', function() {
        if($inputField.val().trim() === '') {
            $submitButton.prop('disabled', false);
        } else {
            $submitButton.prop('disabled', true);
        }
    });

})

$(document).on("click", ".faq-navigation .box", function() {
    var faqContent = $(this).closest(".box").find(".faq-content");
    faqContent.toggleClass("sHidden ");

    var icon = $(this).find("i");
    icon.toggleClass("fa-arrow-square-down fa-arrow-square-up");
});


 // Function to find and display the breadcrumb trail for a selected link
function findBreadcrumbForSelectedLink() {
    // The tree menu is commonly rendered more than once (e.g. desktop + mobile),
    // so scope to a single visible menu and dedupe items defensively.
    const $menuContainer =
        $('.lawguide:visible').first()
            .add($('.collection:visible').first())
            .add($('.TreeMenu:visible').first())
            .filter(':visible')
            .first();

    const $selectedItems = ($menuContainer.length ? $menuContainer.find('a.open') : $('a.open'));

    if ($selectedItems.length) {
        const breadcrumbTrail = [];
        const seen = new Set();

        $selectedItems.each(function () {
            const href = $(this).attr("href") || "";
            const text = $(this).text().trim();

            // Skip empties and duplicates (desktop/mobile menus can duplicate the open path)
            const key = `${href}||${text}`;
            if (!text || seen.has(key)) return;
            seen.add(key);

            breadcrumbTrail.push(href ? `<a href="${href}">${text}</a>` : text);
        });

        const breadcrumbString = breadcrumbTrail.join('<div class="information-break"></div>');
        $("span.current").html(breadcrumbString);
    }
  }

  // Call the function when the page loads
  $(document).ready(function() {
    findBreadcrumbForSelectedLink();
  });

$(document).ready(function() {
    if ($('.business-guide').length > 0 && $('.personal-guide').length > 0) {
        $('.business-guide-title').show();
        $('.personal-guide-title').show();
    } else if ($('.business-guide').length > 0 || $('.personal-guide').length > 0) {
        $('.business-guide-title').hide();
        $('.personal-guide-title').hide();
    }

    $('.notification_close').on('click', function(){
        // There could be many notifications on the page, so hide only the immediate parent
        $(this).closest('.notification').hide(); 
    });
    
    if($("#selectorReminderWrapper").length > 0) {
        // Make a call to the server to check if the customer has used any selectors
        $.ajax({
            url: "?event=mySelectors",
            type: "GET",
            success: function(response) {
                // If JSON readable, parse the response
                if(typeof response === "string") {
                    response = JSON.parse(response);
                }
                // If the response is successful, check if the customer has used any selectors
                if(response.SUCCESS && response.DATA?.TITLE) {
                    // Write the title, date used (convert to long month and short day) and a link to the selector
                    $("#selectorReminderWrapper .recentLink").attr('href', ele.uri.buildUrl(response.DATA.EVENT));
                    $("#selectorReminderWrapper .title").html(`${response.DATA.TITLE}`);
                    $("#selectorReminderWrapper .healthcheck-details").html(`${response.DATA.EFFECTIVEDATE}`);                    
                }
            }
        });
    }
});

function updateMainMargin() {
    const navbar = document.querySelector('.navbarV2');
    const bannersize = document.querySelector('.HomePageUS .banner-container.home.post-login-banner');

    if (navbar && bannersize) {
        const navbarHeight = navbar.offsetHeight;
        // Reset the height first to get the natural height
        bannersize.style.height = 'auto';
        // Get the natural banner height
        const bannerHeight = bannersize.offsetHeight;
        // Now set the final height
        bannersize.style.height = `${navbarHeight + bannerHeight}px`;
    }
}

// Run the function on load and when window resizes
window.addEventListener('load', updateMainMargin);
window.addEventListener('resize', updateMainMargin);

// end of ele2023.js


$(function() {

    var jurisdictionSelector = $('#jurisdictionSelector')
    var navPills = $('.nav-pills');
    if (jurisdictionSelector.val() === '-') {
        // If yes, hide the nav-pills
        navPills.hide();
    }

    
    $(document).ready(function () {
        // Get the dropdown and nav-pills elements
        var jurisdictionSelector = $('#jurisdictionSelector');
        var navPills = $('.nav-pills');

        // Add an event listener to the dropdown
        jurisdictionSelector.change(function () {
            // Check if the selected value is "-"
            if (jurisdictionSelector.val() === '-') {
                // If yes, hide the nav-pills
                navPills.hide();
            } else {
                // If no, show the nav-pills
                navPills.show();
            }
        });
    });
});